import createCollectionStoreClass from './lib/create_collection_store_class';
import NotificationConverter from '../immutable_converters/notification_converter';

const NotificationsStore = createCollectionStoreClass({
  converter: NotificationConverter,
});

export default NotificationsStore;
